<template>
  <div
    class="app-content content"
    :class="[{'show-overlay': $store.state.app.shallShowOverlay}, $route.meta.contentClass]"
  >
    <div class="content-overlay" />
    <div class="header-navbar-shadow" />
    <div
      class="content-wrapper"
      :class="contentWidth === 'boxed' ? 'container p-0' : null"
    >
      <!-- Enhanced Alerts Section using B-Alert -->
      <div
        v-if="alertList.length > 0"
        class="alerts-container mb-2"
      >
        <template v-for="(item, index) in alertList">
          <b-alert
            :key="index"
            :variant="item.estilo"
            show
            dismissible
            class="modern-alert-custom"
            @dismissed="dismissAlert(index)"
          >
            <div class="alert-content-custom">
              <div class="alert-icon-custom">
                <feather-icon
                  :icon="getAlertIcon(item.estilo)"
                  size="20"
                />
              </div>
              <div class="alert-body-custom">
                <h6
                  v-if="item.titulo"
                  class="alert-title-custom"
                >
                  {{ item.titulo }}
                </h6>
                <div
                  class="alert-message-custom"
                  v-html="item.mensagem"
                />
              </div>
            </div>
          </b-alert>
        </template>
      </div>

      <slot name="breadcrumb">
        <app-breadcrumb />
      </slot>

      <div class="content-body">
        <transition
          :name="routerTransition"
          mode="out-in"
        >
          <slot />
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import { BAlert } from 'bootstrap-vue'
import { getContext } from '@/auth/utils'
import store from '@/store'

export default {
  components: {
    AppBreadcrumb,
    BAlert,
  },

  computed: {
    alertList() {
      const alertList = []
      this.$store.state.alerta.alertas.forEach(item => {
        // if (item.produto.toLowerCase() === getContext()) {
        alertList.push(item)
        // }
      })
      return alertList
    },
  },

  setup() {
    const { routerTransition, contentWidth } = useAppConfig()

    const contexto = getContext()
    store.dispatch('alerta/getAlerta', contexto)
      .then(() => {})

    return {
      routerTransition,
      contentWidth,
    }
  },

  methods: {
    getAlertIcon(variant) {
      const iconMap = {
        success: 'CheckCircleIcon',
        danger: 'AlertTriangleIcon',
        warning: 'AlertCircleIcon',
        info: 'InfoIcon',
        primary: 'BellIcon',
        secondary: 'MessageSquareIcon',
        light: 'InfoIcon',
        dark: 'InfoIcon',
      }
      return iconMap[variant] || 'InfoIcon'
    },

    dismissAlert(index) {
      // Remove alert from store
      this.$store.commit('alerta/REMOVE_ALERT', index)
    },
  },
}
</script>

<style lang="scss" scoped>
.alerts-container {
  margin: 0;
  padding: 0;

  &:empty {
    display: none;
  }
}
</style>
